import { BRAND_DISPLAY_NAME } from '@streamlain/brand';

import type { SeniorTool } from './extension/index.js';

/** A senior tool with what places it in the row. */
export interface SeniorToolPlace {
  readonly id: string;
  readonly tool: Pick<SeniorTool, 'name' | 'priority'>;
  /** Its place among the registered tools. */
  readonly index: number;
}

/**
 * The branded tool first, Template last (by registration id, the name is localized); between them
 * by priority, tools of one priority in their registration order.
 */
export function compareSeniorTools(a: SeniorToolPlace, b: SeniorToolPlace) {
  const aIsTemplate = a.id === 'template';
  const bIsTemplate = b.id === 'template';
  if (aIsTemplate !== bIsTemplate) return aIsTemplate ? 1 : -1;
  const aIsBrand = a.tool.name === BRAND_DISPLAY_NAME;
  const bIsBrand = b.tool.name === BRAND_DISPLAY_NAME;
  if (aIsBrand !== bIsBrand) return aIsBrand ? -1 : 1;
  const byPriority = (b.tool.priority ?? 0) - (a.tool.priority ?? 0);
  return byPriority || a.index - b.index;
}
